<template>
  <div  class="addOrgBox">
    <el-scrollbar style="height: calc(100vh - 144px)" ref="scrollbar">
      <div class="createdInner">
        <el-form :model="OrgAddForm"
                 ref="OrgAddForm"
                 label-width="100px"
                 class="demo-ruleForm"
                 label-position="top"
                 :status-icon="true"
                 :show-message="false"
                 :rules="orgAddRules"
        >
          <div class="topTask">
            <el-form-item label="Business Name (Short)" required prop="business_name">
              <el-input v-model="OrgAddForm.business_name" placeholder="Company name"></el-input>
            </el-form-item>
            <el-form-item label="Legal Company Name" required prop="legal_company_name">
              <el-input v-model="OrgAddForm.legal_company_name" placeholder="Legal business name"></el-input>
            </el-form-item>
            <el-form-item label="Registered address" required>
              <composeInput ref="reg_address"></composeInput>
            </el-form-item>
            <el-form-item label="GST/HST number (followed by RT 0001)">
              <el-input v-model="OrgAddForm.gst_hst_number" placeholder="GST/HST number"></el-input>
            </el-form-item>
            <el-form-item label="Phone number" required prop="phone">
            <div style="display: flex">
              <div class="left">
                <el-form-item>
                  <el-select v-model="OrgAddForm.phone_code" popper-class="sb">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="rights">
                <el-form-item  prop="phone" required>
                  <el-input v-model="OrgAddForm.phone" placeholder="Phone number"></el-input>
                </el-form-item>
              </div>
            </div>
            </el-form-item>
            <el-form-item label="Email" required prop="email">
              <el-input v-model="OrgAddForm.email" placeholder="Email"></el-input>
            </el-form-item>


            <el-form-item label="Rate per task" required prop="rate_per_task">
              <div class="rate_box">
                <div style="position: absolute;top: 6px;left: 16px;z-index: 9">$</div>
                  <el-input v-model="OrgAddForm.rate_per_task" placeholder="Rate"></el-input>
              </div>
            </el-form-item>
            <el-form-item label=" Billing Cycle" required prop="billing_cycle">
              <el-select v-model="OrgAddForm.billing_cycle" placeholder="placeholder" @change="changeBillHandle">
                <el-option
                  v-for="item in bill_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" GST/HST rate in " required prop="rate_tax_id">
              <el-select v-model="OrgAddForm.rate_tax_id" placeholder="Select the province the organization is located in">
                <el-option
                  v-for="item in rate_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Amounts are" required prop="price_tax_status">
              <el-select v-model="OrgAddForm.price_tax_status" placeholder="placeholder">
                <el-option
                  v-for="item in price_options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-scrollbar>
    <div class="footers">
      <div>
        <el-button type="success" @click="cancelAddOrg" class="changes">Cancel</el-button>
        <el-button @click="confirmAddOrg" class="changeCreate">Save</el-button>
      </div>
    </div>
<!--    修改bill类型 -->
    <el-dialog
      :modal="false"
      title="Change the billing cycle"
      :visible.sync="changeTypeDialog"
      top="5vh"
      width="32%"
    >
      <div style="margin-top: 24px">
        Would you like to change the billing cycle? Current uninvoiced tasks as of now will be consolidated into a new invoice. Subsequent tasks will be invoiced according to the new billing cycle.
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="noChangeHandle" plain>No</el-button>
          <el-button type="primary" round @click="confirmChangeHandle">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import composeInput from "@/components/composeInput";
import {getRate} from "@/api/inbox";
import {addNewOra, editNewOra} from "@/api/organization";
export default {
  name: "addOrganization",
  components:{
    composeInput
  },
  props:{
    editInfo:{
      default:()=>{},
      type:Object
    }
  },
  data(){
    return{
      options:[
        {label:"+1",value:1},
      ],
      orgAddRules:{
        business_name: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        legal_company_name: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        gst_hst_number: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        phone: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        email: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        rate_per_task: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
        rate_tax_id: [
          {required: true, message: '', trigger: ['blur', 'change']}
        ],
      },
      changeTypeDialog:false,
      bill_options:[
        {value:1,label:'weekly'},
        {value:2,label:'Biweekly'},
        {value:3,label:'Monthly'},
      ],
      price_options:[
        {value:1,label:'Exclusive'},
        {value:2,label:'Inclusive'},
        {value:3,label:'Out of scope'},
      ],
      rate_options:[],
      OrgAddForm:{
        business_name:'',
        legal_company_name:'',
        gst_hst_number:'',
        phone:"",
        email:'',
        rate_per_task:'',
        billing_cycle:1,
        rate_tax_id:'',
        price_tax_status:1,
        phone_code:1
      },
      papre_bill_type:'',
    }
  },
  //监听 billing_cycle 将旧的值存起来 如果点击弹框 no 则将旧的值重新赋给billing_cycle
  watch:{
    "OrgAddForm.billing_cycle":{
      handler(val,old){
        this.papre_bill_type = old
      }
    },
  },
  //监听 父组件传过来的
  created() {
    if (this.editInfo!= ''){
      setTimeout(()=>{
        this.OrgAddForm = this.editInfo
        this.$refs.reg_address.changeForm.address = this.editInfo.address
        this.$refs.reg_address.changeForm.city = this.editInfo.city
        this.$refs.reg_address.changeForm.postcode = this.editInfo.postcode
        this.$refs.reg_address.changeForm.abs = this.editInfo.abs
        this.$refs.reg_address.changeForm.province = this.editInfo.province
      },300)
    }
    getRate().then(res=>{
      this.rate_options = res.data
    })
  },
  methods:{
    //校验表单
    validateForm() {
      let flag = false
      this.$refs['OrgAddForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },

    cancelAddOrg(){
      this.$emit('closeAdd')
    },
    changeBillHandle(v){
      this.changeTypeDialog = true
    },
    confirmChangeHandle(){
      this.changeTypeDialog =false
    },
    noChangeHandle(){
      this.OrgAddForm.billing_cycle = this.papre_bill_type
      this.changeTypeDialog = false
    },
    confirmAddOrg(){
      let obj1 = this.OrgAddForm
      let obj2 = this.$refs.reg_address.changeForm
      let form = {...obj1,...obj2}
      form.country ='Canada'
      form.phone_code = 1
      if (this.validateForm()){
        //校验通过
        if (this.editInfo == ''){
          //新增
          addNewOra(form).then(res=>{
            if (res.code == 200){
              this.$emit('closeAdd')
              this.$message({
                type:"success",
                message:res.msg
              })
            }else {
              this.$message({
                type:"warning",
                message:res.msg
              })
            }
          }).catch(err=>{
            this.$message({
              type:'error',
              message:err.msg
            })
          })
        }else {
          editNewOra(form).then(res=>{
            if (res.code == 200){
              this.$emit('closeAdd')
              this.$message({
                type:"success",
                message:res.msg
              })
            }else {
              this.$message({
                type:"warning",
                message:res.msg
              })
            }
          }).catch(err=>{
            this.$message({
              type:'error',
              message:err.msg
            })
          })
        }
      }else {
        this.$message({
          type:'warning',
          message:'Some information missing'
        })
      }

    },
    clearTheForm() {
      this.$refs.reg_address.validateClear()
     this.$refs['OrgAddForm'].resetFields()
    },
  }
}
</script>

<style scoped lang="less">
.addOrgBox{
    margin-left: 8px;
    /deep/.el-scrollbar__wrap{
      overflow: auto;
    }
  .createdInner{
    width: 500px;
    margin:0 auto;
    .left{
      flex: 1;
      /deep/ .el-input__inner{
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        border-right: none;
      }
    }
    .rights{
      flex: 3;
      /deep/ .el-input__inner{
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
      }
    }
    .rate_box{
      display: flex;
      position: relative;
      /deep/.el-input__inner{
        padding-left: 32px;
      }
    }
  }
    .footers{
      width:calc( 100% - 72px);
      z-index: 1;
      height: 64px;
      background: #1F2D42;
      position: fixed;
      bottom: 0;
      margin-left: -32px;
      line-height: 64px;
      display: flex;
      flex-direction: row-reverse;
      padding-right: 48px;
      padding-left: 32px;
      color: #FFFFFF;
      .changeCreate{
        color: #1F2D42;
      }
      .changeCreate:focus{
        border-color: #FFFFFF;
        background-color: #FFFFFF;
      }
      .changes{
        border: 1px solid #FFFFFF!important;
      }
      .changeCreate:hover{
        border-radius: 16px;
        border: 1px solid #FFFFFF;
        background: #1F2D42;
        color: #FFFFFF;
      }
    }
}
</style>
